import _ from "lodash";
/** external */
import React, { useEffect } from "react";
import { connect } from "react-redux";

/** internal */
import ACLStore from "lib/aclStore";
import { ENABLE_SHORTCUT_MANAGER } from "Constants/permissionConstants";
import {
  addFeaturesWithKeyboardShortcuts,
  removeFeaturesWithKeyboardShortcuts,
} from "modules/Services";

/** relative */
import ShortcutManager from "./ShortcutManager";

const ShortcutManagerWrapper = props => {
  const {
    addFeaturesWithKeyboardShortcuts,
    removeFeaturesWithKeyboardShortcuts,
    isVisible,
  } = props;

  const isFeatureEnabled = ACLStore.can(ENABLE_SHORTCUT_MANAGER);

  useEffect(() => {
    if (isFeatureEnabled) {
      addFeaturesWithKeyboardShortcuts(["SHORTCUT_MANAGER"]);
    }

    return () => {
      if (isFeatureEnabled) {
        removeFeaturesWithKeyboardShortcuts(["SHORTCUT_MANAGER"]);
      }
    };
  }, []);

  return isVisible ? <ShortcutManager /> : null;
};

const mapStateToProps = state => {
  const isVisible =
    _.get(state, "app_services.activeFeatureWithKeyboardShortcuts") ===
    "SHORTCUT_MANAGER";

  return {
    isVisible,
  };
};

const mapActionCreators = {
  addFeaturesWithKeyboardShortcuts,
  removeFeaturesWithKeyboardShortcuts,
};

export default connect(
  mapStateToProps,
  mapActionCreators
)(ShortcutManagerWrapper);
